import * as React from 'react';
import { clsx } from 'clsx';
import type { MenuData } from "../../js/data/menuData.ts";
import type { MenuItemData } from "../../js/data/menuItemData.ts";
import MenuItemTitle from "./menuItemTitle.tsx";
import { useHoverIntent } from "react-use-hoverintent";

type MenuItemProps = React.ComponentPropsWithoutRef<"li"> & {
	menu: MenuData,
	item: MenuItemData,
	depth?: number,
	pathname: string,
	index: number,
	siblingsCount: number,
	separator?: string|React.ReactElement
	classNameAnchor?: string,
}

export function filterMenuItemsByParent(menu: MenuData, parentId: number): MenuItemData[] {
	if (!Array.isArray(menu?.menuItems)) {
		return [];
	}

	return menu?.menuItems?.filter((menuItem: any) => {
		return menuItem.parentId === parentId;
	});
}

function MenuItem({
	menu,
	item,
	pathname,
	depth = 0,
	className,
	classNameAnchor,
	index,
	siblingsCount,
	separator = null,
	...otherProps
}: MenuItemProps){
	const subMenuItems = filterMenuItemsByParent(menu, item.nodeId);
	const [isHovering, intentRef] = useHoverIntent({
		timeout: 200,
	});

	return (<>
		<li ref={intentRef} className={clsx(subMenuItems.length && "withSubMenu", isHovering && "intent", className)} {...otherProps}>

			<MenuItemTitle item={item} subMenuItems={subMenuItems} depth={depth} pathname={pathname} className={classNameAnchor}/>
			{(index !== siblingsCount) && separator}

			{subMenuItems.length > 0 && <ul>{
				subMenuItems.map((subItem, i) => {
					return (<MenuItem
						key={"subItem" + i}
						menu={menu}
						item={subItem}
						depth={depth + 1}
						pathname={pathname}
						index={index}
						siblingsCount={siblingsCount}
						separator={separator}
					/>);
				})
			}</ul>}
		</li>
	</>);
}

export default MenuItem;
